<template>
  <div class="p-3 w-full rounded-lg bg-gray-100 shadow text-gray-800">
    <div class="w-full md:text-lg font-semibold mb-2">
      {{ name }}
    </div>
    <div class="flex items-center justify-between">
      <div class="font-bold text-sm md:text-base text-orange-600">
        {{ $rupiah(price) }}
      </div>
      <div class="flex items-center align-middle">
        <button
          :disabled="$store.state.loading"
          class="text-gray-600 mr-4 focus:text-red-600 focus:outline-none disabled:opacity-75 disabled:cursor-not-allowed"
          @click="remove()">
          <svg
            class="w-6 h-6 md:w-8 md:h-8 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><path d="M128 405.429C128 428.846 147.198 448 170.667 448h170.667C364.802 448 384 428.846 384 405.429V160H128v245.429zM416 96h-80l-26.785-32H202.786L176 96H96v32h320V96z" /></svg>
        </button>
        <button
          :disabled="amount <= minimum_purchase || $store.state.loading"
          class="bg-green-600 focus:outline-none  active:bg-green-500 rounded-full font-mono text-xl w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-white disabled:cursor-not-allowed disabled:bg-gray-400"
          @click="decrease()">
          -
        </button>
        <span
          class="mx-2 w-6 focus:outline-none bg-transparent text-sm md:text-lg text-center font-bold text-blue-900"
          type="number">{{ amount }}</span>
        <button
          :disabled="amount >= maximum_purchase || $store.state.loading"
          class="bg-green-600 focus:outline-none  active:bg-green-500 rounded-full font-mono text-xl w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-white disabled:cursor-not-allowed disabled:bg-gray-400"
          @click="increase()">
          +
        </button>
      </div>
    </div>
    <div class="flex items-center justify-end mt-2 pt-2">
      <div class="text-xs md:text-base font-semibold mr-2">
        Subtotal:
      </div>
      <div class="font-bold text-sm md:text-base text-orange-600">
        {{ $rupiah(price * amount) }}
      </div>
    </div>
    <div class="mt-6">
      <div
        v-for="(detail, n) in details"
        :key="n"
        class="mt-3 mb-3">
        <label
          v-if="details.length == 1"
          class="w-full text-xs md:text-base mb-1 block font-semibold"
          for="">E-mail Peserta <span class="text-red-500">*</span></label>
        <label
          v-if="details.length > 1"
          class="w-full text-xs md:text-base mb-1 block font-semibold"
          for="">E-mail Peserta {{ n + 1 }} <span class="text-red-500">*</span></label>
        <input
          v-model.lazy="detail.email"
          :class="{
            'border-red-500': errors['cart.'+index+'.details.'+n+'.email']
          }"
          class="w-full block focus:border-green-400 focus:outline-none bg-transparent border-b text-sm md:text-base p-2"
          type="email"
          @change="resetError()">
        <p
          v-if="errors['cart.'+index+'.details.'+n+'.email']"
          class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
          {{ errors['cart.'+index+'.details.'+n+'.email'][0] }}
        </p>
        <p
          v-else
          class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
          &nbsp;
        </p>
      </div>
    </div>
    <div
      v-if="false"
      class="mt-3 mb-3">
      <label
        class="w-full text-xs md:text-base mb-1 block font-semibold"
        for="">Kota <span class="text-red-500">*</span></label>
      <select
        v-model="city_id"
        class="leading-normal w-full block focus:border-green-400 focus:outline-none focus:border-gray-500 bg-transparent border-b text-sm md:text-base appearance-none p-2"
        :class="{
          'border-red-500': errors['cart.'+index+'.city_id']
        }"
        @change="resetError()">
        <option
          value=""
          disabled="disabled">
          Pilih Kota
        </option>
        <option
          v-for="city in $store.state.cities"
          :key="city.id"
          :value="city.id">
          {{ city.name }}
        </option>
      </select>
      <p
        v-if="errors['cart.'+index+'.city_id']"
        class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
        {{ errors['cart.'+index+'.city_id'][0] }}
      </p>
      <p
        v-else
        class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
        &nbsp;
      </p>
    </div>
    <div class="mt-3 mb-3">
      <label
        class="w-full text-xs md:text-base mb-1 block font-semibold"
        for="">Kategori <span class="text-red-500">*</span></label>
      <select
        v-model="major_id"
        class="leading-normal w-full block focus:border-green-400 focus:outline-none focus:border-gray-500 bg-transparent border-b text-sm md:text-base appearance-none p-2"
        :class="{
          'border-red-500': errors['cart.'+index+'.major_id']
        }"
        @change="resetError()">
        <option
          value=""
          disabled="disabled">
          Pilih Kategori
        </option>
        <option
          v-for="major in $store.state.majors"
          :key="major.id"
          :value="major.id">
          {{ major.name }}
        </option>
      </select>
      <p
        v-if="errors['cart.'+index+'.major_id']"
        class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
        {{ errors['cart.'+index+'.major_id'][0] }}
      </p>
      <p
        v-else
        class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
        &nbsp;
      </p>
    </div>
    <div
      v-if="details.length > 1"
      class="mt-3 mb-3 text-xs md:text-sm leading-snug">
      <strong>Petunjuk</strong>
      <p class="p-2 pt-1 pb-0">
        Data e-mail peserta dibutuhkan untuk diberikan akses ke fasilitas Olimpiade online.
      </p>
      <p class="p-2 pt-1 pb-0">
        Kamu dapat memperbarui/mengubah data email peserta, kota, dan jurusan untuk masing-masing peserta setelah menyelesaikan pembayaran.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id', 'name', 'price', 'cart_discount','minimum_purchase', 'maximum_purchase'],
  data() {
    return {
      city_id: '',
      major_id: '',
    };
  },
  computed: {
    errors () {
      return this.$store.state.errors;
    },
    index() {
      return this.$store.getters.userProductIndexById(this.id);
    },
    userProduct() {
      return this.$store.getters.userProductById(this.id);
    },
    details: {
      get() {
        if (this.userProduct.details.length < this.amount) {
          for (var i = this.userProduct.details.length; i < this.amount; i++) {
            this.addBlankDetail();
          }
        } else if (this.userProduct.details.length > this.amount) {
          for (var i = this.userProduct.details.length; i > this.amount; i--) {
            this.popDetail();
          }
        }

        return this.userProduct.details;

      },
      set(value) {
        this.$store.commit('updateUserProductById', {
          id: value[0].user_product_id,
          details: value,
        });
      },
    },
    amount: {
      get() {
        return this.$store.getters.userProductById(this.id).amount;
      },
      set(value) {
        value = parseInt(value) || 0;
        if (value < this.minimum_purchase) {
          value = this.minimum_purchase;
        } else if (value > this.maximum_purchase) {
          value = this.maximum_purchase;
        }

        this.$store.commit('updateUserProductById', {
          id: this.id,
          amount: value,
        });
        this.$forceUpdate();
      },
    },
  },
  watch: {
    details: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal[0].email == '') {
          newVal[0].email = this.$store.state.user.email;
        }
        this.details = newVal;
      }
    },
    city_id(value) {
      this.$store.commit('updateUserProductById', {
        id: this.id,
        city_id: value,
      });
    },
    major_id(value) {
      this.$store.commit('updateUserProductById', {
        id: this.id,
        major_id: value,
      });
    },
  },
  mounted() {
  },
  methods: {
    increase() {
      if (this.amount < this.minimum_purchase) {
        this.amount = this.minimum_purchase;
        return;
      }
      if (this.amount > this.maximum_purchase) {
        this.amount = this.maximum_purchase;
        return;
      }
      this.amount++;
    },
    decrease() {
      if (this.amount < this.minimum_purchase) {
        this.amount = this.minimum_purchase;
        return;
      } else if (this.amount > this.maximum_purchase) {
        this.amount = this.maximum_purchase;
        return;
      }
      this.amount--;
    },
    async remove() {
      try {
        this.$store.commit('setLoading', true);
        await this.$store.dispatch('pushDeleteUserProductById', this.id);
        this.$store.commit('deleteUserProductById', this.id);
        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        throw error;
      }
    },
    addBlankDetail() {
      this.$store.commit('addUserProductDetail', {
        user_product_id: this.id,
        data: {
          user_product_id: this.id,
          email: '',
        },
      });
    },
    popDetail() {
      this.$store.commit('popUserProductDetail', this.id);
    },
    resetError() {
      this.$store.commit('setErrors', {});
    },
  },
}
</script>
